import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useBreakpoint, useMediaAsset } from '~/composables';
import UiEnergyLabelLink from '~/components/ui/UiEnergyLabelLink.vue';
import { getProductFeatureValueById } from '~/helpers/vue';

interface Props {
  data?: any;
  product?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSeriesHeader',
  props: {
    data: { default: () => ({}) },
    product: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any, product: any };



const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isBiggerSm } = useBreakpoint('sm');

const similarProducts = computed(() =>
  props?.product?.similar_products?.[0].items
    .filter((item: any) => item.active)
    .map((item: any) => ({
      ...item,
      link: `/product/${item.slug}`,
    })),
);

const energyLabelLink = computed(() =>
  getProductFeatureValueById(
    'ADDITIONAL_INFORMATION',
    'EPREL',
    props.product?.feature_groups,
  ),
);

const energyLabelSymbol = computed(() =>
  getProductFeatureValueById(
    'ADDITIONAL_INFORMATION',
    'ENERGY_LABEL',
    props.product?.feature_groups,
  ),
);

const backgroundImage = computed(() =>
  getAssetUrl(
    !isBiggerSm.value && props.data?.backgroundImage?.mobile
      ? props.data?.backgroundImage?.mobile
      : props.data?.backgroundImage?.desktop,
  ),
);

return { __sfc: true,props, getAssetUrl, isBiggerSm, similarProducts, energyLabelLink, energyLabelSymbol, backgroundImage, UiEnergyLabelLink }
}

})